module.exports = __webpack_public_path__ + "static/datetime-local-d5527691839800baddefdc09dbfdd041.png";